import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    errorPage: null,
    updateModal: false
  },
  getters: {
    updateModal (state) {
      return state.updateModal
    },
    errorPage (state) {
      return state.errorPage
    },
    whatsappLink () {
      return 'https://wa.me/5581981812327'
    }
  },
  mutations: {
    'SET_ERROR_PAGE' (state, errorPage) {
      if (errorPage) state.errorPage = errorPage
      else state.errorPage = null
    },
    'SET_UPDATE_MODAL' (state, isVisible) {
      state.updateModal = isVisible
    }
  },
  actions: {
  }
})
